/* istanbul ignore file */

/** This is a placeholder, not real render in dom */
const Option = () => null;
Option.isSelectOption = true;
export default Option;